export default {"src":"/_next/static/media/attempt_error.cd0cd5d3.svg","height":219,"width":351,"blurWidth":0,"blurHeight":0};